
import { TurnOrderTypes } from '../constants/turnorderConstants';

const initialState = {
    opened: false,
    items: [],
    currentTurn: 1,
};

export const turnorderReducer = (state = initialState, action) => {
    switch (action.type) {
        case TurnOrderTypes.OPEN_TURNORDER:
            return {
                ...state,
                opened: true
            };
        case TurnOrderTypes.CLOSE_TURNORDER:
            return {
                ...state,
                opened: false
            };

        case TurnOrderTypes.TOGGLE_TURNORDER:
            return {
                ...state,
                opened: !state.opened
            };

        case TurnOrderTypes.SET_TURNORDER:
            return {
                ...state,
                items: [...action.items]
            };

        case TurnOrderTypes.SET_TURNS:
            return {
                ...state,
                currentTurn: action.num
            };

        case TurnOrderTypes.ADD_TURNORDER:
            return {
                ...state,
                items: [...state.items, {...action.item}]
            };

        case TurnOrderTypes.REMOVE_TURNORDER:
            return {
                ...state,
                items: [...state.items].filter(s => s.id !== action.id)
            };

        case TurnOrderTypes.EDIT_TURNORDER:
            return {
                ...state,
                items: [...state.items].map(s => s.id !== action.id ? s : {...action.item})
            };

        case TurnOrderTypes.RESET:
            return {...initialState}
        
        default:
            return state;
    }
};